import * as yup from "yup";

import { FLEET_VEHICLE_STATUS_DETAIL_FIELDS } from "services/api/fleet/vehicles/consts";
import { FleetVehicleStatusEnum } from "services/api/fleet/vehicles/types";
import { VEHICLE_LOCATION_SCHEMA } from "../../../VehicleLocationFields/validation";

/** Polje iz konfiguracije → ime u form values. */
const FIELD_TO_FORM_KEY: Record<string, string> = {
  contact: "contactId",
  driver: "driverId",
  damage: "vehicleDamageId",
  offerSale: "offerSaleId",
  validFrom: "validFrom",
  validUntil: "validUntil",
  note: "note",
  kmTraveled: "kmTraveled",
  depositAmount: "depositAmount",
  location: "location",
};

/**
 * Shema se gradi iz iste konfiguracije koja crta polja, pa se prikaz i validacija
 * ne mogu razići. Obavezna polja moraju odgovarati `VehicleStatusDetailValidator` na backendu.
 */
export const buildStatusDetailSchema = (status: FleetVehicleStatusEnum) => {
  const fields = FLEET_VEHICLE_STATUS_DETAIL_FIELDS[status] ?? [];
  const shape: Record<string, yup.AnySchema> = {};

  fields.forEach((field) => {
    const key = FIELD_TO_FORM_KEY[field.field];

    // Lokacija nosi vlastita pravila po vrsti — ne svodi se na "obavezno / nije".
    if (field.field === "location") {
      shape[key] = VEHICLE_LOCATION_SCHEMA.nullable();
      return;
    }

    if (!field.required) return;

    const message = `${field.label} je obavezan podatak`;

    shape[key] =
      field.field === "validFrom" || field.field === "validUntil"
        ? yup.date().nullable().required(message)
        : yup.string().nullable().required(message);
  });

  return yup.object().shape(shape);
};
